import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import type { CubeControlProps, ICubeButtonsController, ICubeController, ICubeControllerFactory } from './interfaces';
import styled from 'styled-components';
import { TYPES } from './types';
import ArrowsControl from './arrowsControl';
import { Canvas } from '../canvas/Canvas';
import { useInjection } from 'inversify-react';

export const CubeControl: React.FC<CubeControlProps> = ({ bgColor, integrationApi }) => {
  const cubeControllerFactory = useInjection<ICubeControllerFactory>(TYPES.ICubeControllerFactory);
  const [cubeController, setCubeController] = useState<ICubeController>();
  const [buttonsController, setButtonsController] = useState<ICubeButtonsController>();

  const setCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const controller = cubeControllerFactory.createCubeController(integrationApi);
    setCubeController(controller);
    setButtonsController(controller?.getButtonsController());
    return (): void => {
      controller.dispose();
    };
  }, [cubeControllerFactory, integrationApi]);

  useEffect(() => {
    const canvas = setCanvasRef.current;
    if (canvas && cubeController) {
      cubeController.getSceneController().onCanvasChanged(canvas, bgColor);
    }
  }, [bgColor, cubeController]);

  return (
    <Container>
      <ArrowsControl cubeButtonsController={buttonsController} />
      <Canvas ref={setCanvasRef} width={200} height={200} />
    </Container>
  );
};

export default CubeControl;

const Container = styled.div`
  position: absolute;
  right: 50px;
  bottom: 110px;
  font-size: '0.75em';
`;
